import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';

export interface IWaiveDepositDialogData {
  waiverReason?: string;
}

export interface IWaiveDepositDialogResult {
  waiverReason: string;
}

@Component({
  selector: 'pr-waive-deposit-dialog',
  templateUrl: './waive-deposit-dialog.component.html',
  styleUrls: ['./waive-deposit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule],
})
export class WaiveDepositDialogComponent {
  form: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<WaiveDepositDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IWaiveDepositDialogData
  ) {
    this.form = this._formBuilder.group({
      waiverReason: [
        data?.waiverReason || '',
        [Validators.required, Validators.minLength(3)],
      ],
    });
  }

  get waiverReasonControl(): AbstractControl | undefined {
    return this.form.get('waiverReason') ?? undefined;
  }

  get hasRequiredError(): boolean {
    return this.waiverReasonControl?.hasError('required') ?? false;
  }

  get hasMinLengthError(): boolean {
    return this.waiverReasonControl?.hasError('minlength') ?? false;
  }

  onCancel(): void {
    this._dialogRef.close(undefined);
  }

  onConfirm(): void {
    if (this.form.valid) {
      const waiverReason = this.form.get('waiverReason')?.value as string;
      const result: IWaiveDepositDialogResult = {
        waiverReason,
      };
      this._dialogRef.close(result);
    }
  }
}
